module.exports = __webpack_public_path__ + "img/magento-custom-development.47b08870.jpeg";